import { StyleSheet, Text, View } from '@react-pdf/renderer';
import { extractResumeDataDocumentSection } from "../../../hooks/useResumeDocumentSection";
import { extractResumeProperties } from "../../../hooks/useResumeProperties";

export default function EuropassPdfBusinessSkillsSection( { resumeData, translations } ) {
    const { businessSkills } = extractResumeDataDocumentSection( resumeData );
    const { documentLanguage } = extractResumeProperties( resumeData );

    const styles = StyleSheet.create( {
        textStart: {
            fontFamily: "Verdana, sans-serif",
            fontSize: "9px",
            margin: 0,
            marginTop: 4,
            textAlign: "right"
        },
        sectionCompetence: {
            flexDirection: 'row',
            flexWrap: 'wrap',
        },
        categoryColumn: {
            width: '25%',
        },
        category: {
            fontSize: 8,
            color: "#3F3F3F",
            marginBottom: 1,
            marginTop: 3,
            textAlign: 'start',
            fontWeight: 'bold',
        },
        competence: {
            width: '50%',
            marginBottom: 0,
            flexDirection: 'row',
            alignItems: 'center',
        },
        competenceName: {
            fontSize: 8,
            margin: 1,
            width: "40%",
            marginRight: 5,
            marginLeft: 2,
            textAlign: 'start',
        },
        lineTitle: {
            height: 1,
            backgroundColor: "#979797",
            marginRight: 10,
            marginBottom: 5,
        }
    } );

    return (
        <View style={ { marginTop: 10, paddingHorizontal: 20, marginRight: 40 } } wrap={ false }>
            <View style={ { flexDirection: "row", marginBottom: 4 } }>
                <Text style={ { fontSize: 11, marginRight: 3 } }>•</Text>
                <Text style={ { fontWeight: "bold", textTransform: "uppercase", fontSize: 9, marginTop: 2 } }>
                    { translations.pdf.businessSkillsTitle }
                </Text>
            </View>
            <View style={ [ styles.lineTitle, { marginTop: 1 } ] }/>
            { businessSkills
                .sort( ( a, b ) => a.order - b.order )
                .map( ( category, index ) => {
                    const categoryLabel =
                        category?.category?.translations?.[ documentLanguage ]
                        || category?.category?.label
                        || '';

                    return (
                    <View key={ index }>
                        <View style={ [
                            styles.sectionCompetence,
                            { display: "flex", flexDirection: "column" }
                        ] }>
                            <View style={ styles.categoryColumn }>
                                <Text style={ [
                                    styles.category,
                                    { fontWeight: "bold", color: "#000000", fontSize: 8 }
                                ] }>
                                    { categoryLabel }
                                </Text>
                            </View>
                            <View>
                                <View style={ styles.sectionCompetence }>
                                    { category.competences
                                        .sort( ( a, b ) => a.order - b.order )
                                        .map( ( competence, subIndex ) => (
                                            <View key={ subIndex }
                                                  style={ { flexDirection: "row", alignItems: "center" } }
                                            >
                                                { subIndex > 0 &&
                                                    <Text style={ { marginLeft: 5, color: "#3F3F3F" } }>
                                                        { ' ' }|{ ' ' }
                                                    </Text> }
                                                <Text style={ [ styles.textStart, { fontSize: 8 } ] }>
                                                    { competence.translations[ documentLanguage ] }
                                                </Text>
                                            </View>
                                        ) ) }
                                </View>
                            </View>
                        </View>
                    </View>
                    );
                } ) }
        </View>
    );
}
